import { render } from "./SensorWeight.vue?vue&type=template&id=1d556f2e"
import script from "./SensorWeight.vue?vue&type=script&lang=js"
export * from "./SensorWeight.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__